"use strict";
var $a5fd07fa01589658$exports = {};
/* eslint-disable no-shadow */ "use strict";
class $a5fd07fa01589658$var$Game {
    constructor(initialState){
        this.size = 4;
        this.board = initialState || this.createEmptyBoard();
        this.score = 0;
        this.history = [];
        this.scoreHistory = [];
        this.undoCount = 2;
        this.shuffleCount = 1;
        this.removeCount = 0;
        this.has256 = false;
        this.has512 = false;
        this.status = "idle";
    }
    moveLeft() {
        if (this.status !== "playing") return;
        this.savePreviousState();
        let moved = false;
        for(let i = 0; i < this.size; i++){
            const row = this.board[i].filter((val)=>val !== 0);
            for(let j = 0; j < row.length - 1; j++)if (row[j] === row[j + 1]) {
                row[j] *= 2;
                this.score += row[j];
                row[j + 1] = 0;
                this.checkWin(row[j]);
                this.checkUnlocks(row[j]);
            }
            const newRow = row.filter((val)=>val !== 0);
            while(newRow.length < this.size)newRow.push(0);
            if (this.board[i].toString() !== newRow.toString()) moved = true;
            this.board[i] = newRow;
        }
        if (moved) {
            this.addRandomTile();
            if (this.isGameOver()) this.status = "lose";
        }
    }
    moveRight() {
        this.board = this.reverseRows(this.board);
        this.moveLeft();
        if (this.status === "win") return;
        this.board = this.reverseRows(this.board);
    }
    moveUp() {
        this.board = this.transpose(this.board);
        this.moveLeft();
        if (this.status === "win") return;
        this.board = this.transpose(this.board);
    }
    moveDown() {
        this.board = this.transpose(this.board);
        this.board = this.reverseRows(this.board);
        this.moveLeft();
        if (this.status === "win") return;
        this.board = this.reverseRows(this.board);
        this.board = this.transpose(this.board);
    }
    start() {
        if (this.status !== "playing") {
            this.board = this.createEmptyBoard();
            this.addRandomTile();
            this.addRandomTile();
            this.score = 0;
            this.status = "playing";
            this.undoCount = 2;
            this.shuffleCount = 1;
            this.removeCount = 0;
            this.has256 = false;
            this.has512 = false;
        }
    }
    restart() {
        this.status = "idle";
        this.start();
    }
    savePreviousState() {
        this.history.push(this.board.map((row)=>[
                ...row
            ]));
        this.scoreHistory.push(this.score);
        if (this.history.length > 2) {
            this.history.shift();
            this.scoreHistory.shift();
        }
    }
    undo() {
        if (this.undoCount > 0 && this.history.length > 0) {
            this.board = this.history.pop();
            this.score = this.scoreHistory.pop();
            this.undoCount--;
        }
    }
    shuffle() {
        if (this.shuffleCount === 0) return;
        const flat = this.board.flat().filter((v)=>v !== 0);
        for(let i = flat.length - 1; i > 0; i--){
            const j = Math.floor(Math.random() * (i + 1));
            [flat[i], flat[j]] = [
                flat[j],
                flat[i]
            ];
        }
        const newBoard = this.createEmptyBoard();
        flat.forEach((val, i)=>{
            const row = Math.floor(i / this.size);
            const col = i % this.size;
            newBoard[row][col] = val;
        });
        this.board = newBoard;
        this.shuffleCount--;
    }
    remove() {
        if (this.removeCount === 0) return;
        const filled = [];
        for(let i = 0; i < this.size; i++){
            for(let j = 0; j < this.size; j++)if (this.board[i][j] !== 0) filled.push([
                i,
                j
            ]);
        }
        if (filled.length === 0) return;
        const [i, j] = filled[Math.floor(Math.random() * filled.length)];
        this.board[i][j] = 0;
        this.removeCount--;
    }
    checkWin(value) {
        if (value === 2048) this.status = "win";
    }
    checkUnlocks(value) {
        if (value === 256 && !this.has256) {
            this.shuffleCount++;
            this.has256 = true;
        }
        if (value === 512 && this.removeCount < 2) {
            this.removeCount++;
            this.has512 = true;
        }
    }
    createEmptyBoard() {
        return Array.from({
            length: this.size
        }, ()=>Array(this.size).fill(0));
    }
    addRandomTile() {
        const empty = [];
        for(let i = 0; i < this.size; i++){
            for(let j = 0; j < this.size; j++)if (this.board[i][j] === 0) empty.push([
                i,
                j
            ]);
        }
        if (empty.length > 0) {
            const [i, j] = empty[Math.floor(Math.random() * empty.length)];
            this.board[i][j] = Math.random() < 0.9 ? 2 : 4;
        }
    }
    isGameOver() {
        for(let i = 0; i < this.size; i++)for(let j = 0; j < this.size; j++){
            if (this.board[i][j] === 0) return false;
            if (j < this.size - 1 && this.board[i][j] === this.board[i][j + 1]) return false;
            if (i < this.size - 1 && this.board[i][j] === this.board[i + 1][j]) return false;
        }
        return true;
    }
    reverseRows(matrix) {
        return matrix.map((row)=>[
                ...row
            ].reverse());
    }
    transpose(matrix) {
        return matrix[0].map((_, colIndex)=>matrix.map((row)=>row[colIndex]));
    }
    getState() {
        return this.board;
    }
    getScore() {
        return this.score;
    }
    getStatus() {
        return this.status;
    }
}
$a5fd07fa01589658$exports = $a5fd07fa01589658$var$Game;


const $09e991522ca7e64e$var$game = new $a5fd07fa01589658$exports();
const $09e991522ca7e64e$var$boardElement = document.querySelector(".game-field");
const $09e991522ca7e64e$var$scoreElement = document.querySelector(".game-score");
const $09e991522ca7e64e$var$statusElement = document.querySelector(".message-lose");
const $09e991522ca7e64e$var$startButton = document.querySelector(".button.start");
const $09e991522ca7e64e$var$messageStart = document.querySelector(".message-start");
const $09e991522ca7e64e$var$toolsContainer = document.querySelector(".game-tools");
const $09e991522ca7e64e$var$undoButton = document.querySelector(".undo-button");
const $09e991522ca7e64e$var$shuffleButton = document.querySelector(".shuffle-button");
const $09e991522ca7e64e$var$removeButton = document.querySelector(".remove-button");
function $09e991522ca7e64e$var$updateToolButtons() {
    const updateSlots = (button, count, max)=>{
        const slots = Array.from(button.querySelectorAll(".use-slot"));
        slots.forEach((slot, index)=>{
            slot.classList.toggle("used", index < count);
        });
        button.disabled = count === 0;
    };
    updateSlots($09e991522ca7e64e$var$undoButton, $09e991522ca7e64e$var$game.undoCount, 2);
    updateSlots($09e991522ca7e64e$var$shuffleButton, $09e991522ca7e64e$var$game.shuffleCount, 2);
    updateSlots($09e991522ca7e64e$var$removeButton, $09e991522ca7e64e$var$game.removeCount, 2);
}
function $09e991522ca7e64e$var$render() {
    const state = $09e991522ca7e64e$var$game.getState();
    // eslint-disable-next-line no-shadow
    const status = $09e991522ca7e64e$var$game.getStatus();
    const cells = $09e991522ca7e64e$var$boardElement.querySelectorAll(".field-cell");
    cells.forEach((cell, index)=>{
        const row = Math.floor(index / 4);
        const col = index % 4;
        const value = state[row][col];
        cell.textContent = value === 0 ? "" : value;
        cell.className = "field-cell";
        if (value > 0) cell.classList.add(`field-cell--${value}`);
    });
    $09e991522ca7e64e$var$scoreElement.textContent = $09e991522ca7e64e$var$game.getScore();
    switch(status){
        case "win":
            $09e991522ca7e64e$var$statusElement.textContent = "You win!";
            $09e991522ca7e64e$var$statusElement.classList.remove("hidden");
            break;
        case "lose":
            $09e991522ca7e64e$var$statusElement.textContent = "You lose! Restart the game?";
            $09e991522ca7e64e$var$statusElement.classList.remove("hidden");
            break;
        default:
            $09e991522ca7e64e$var$statusElement.classList.add("hidden");
    }
    $09e991522ca7e64e$var$updateToolButtons();
}
document.addEventListener("keydown", (e)=>{
    if ($09e991522ca7e64e$var$game.getStatus() !== "playing") return;
    const keyActions = {
        ArrowLeft: ()=>$09e991522ca7e64e$var$game.moveLeft(),
        ArrowRight: ()=>$09e991522ca7e64e$var$game.moveRight(),
        ArrowUp: ()=>$09e991522ca7e64e$var$game.moveUp(),
        ArrowDown: ()=>$09e991522ca7e64e$var$game.moveDown()
    };
    const action = keyActions[e.key];
    if (action) {
        action();
        $09e991522ca7e64e$var$render();
    }
});
$09e991522ca7e64e$var$startButton.addEventListener("click", ()=>{
    const isIdle = $09e991522ca7e64e$var$game.getStatus() === "idle";
    if (isIdle) {
        $09e991522ca7e64e$var$game.start();
        $09e991522ca7e64e$var$messageStart.classList.add("hidden");
        $09e991522ca7e64e$var$startButton.classList.remove("start");
        $09e991522ca7e64e$var$startButton.classList.add("restart");
        $09e991522ca7e64e$var$startButton.textContent = "Restart";
        $09e991522ca7e64e$var$toolsContainer.classList.remove("hidden");
    } else $09e991522ca7e64e$var$game.restart();
    $09e991522ca7e64e$var$render();
});
$09e991522ca7e64e$var$undoButton.addEventListener("click", ()=>{
    $09e991522ca7e64e$var$game.undo();
    $09e991522ca7e64e$var$render();
});
$09e991522ca7e64e$var$shuffleButton.addEventListener("click", ()=>{
    $09e991522ca7e64e$var$game.shuffle();
    $09e991522ca7e64e$var$render();
});
$09e991522ca7e64e$var$removeButton.addEventListener("click", ()=>{
    $09e991522ca7e64e$var$game.remove();
    $09e991522ca7e64e$var$render();
});
$09e991522ca7e64e$var$render();


//# sourceMappingURL=index.f752c48c.js.map
